module.exports = __webpack_public_path__ + "static/media/people-activity.17c8796c.svg";